<template>
    <div class="news_item" @click.stop="router.push({path: '/art-detail', query: {id: data.id}})">
        <!-- <div :style="{ backgroundImage: `url(${data.bannerUrl})` }" class="banner_img"></div> -->
        <img :src="data.mainImage" alt="">
        <div class="content" >
            <h5>{{ data.artName }}</h5>
            <p>{{ richTextToPlainText(data.introduction) }}</p>
            <div class="icons">
                <img src="@/assets/imgs/icon5.png" alt=""> {{ data.browseCount }}
                <img src="@/assets/imgs/icon6.png" alt=""> {{ data.thumbsUpCount }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { richTextToPlainText } from '@/utils/util.js'
import { useRouter } from 'vue-router';
const router = useRouter()
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})
</script>

<style scoped lang="scss">
.news_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20rem;
    position: relative;
    height: 90rem;
    padding: 0 20rem;

    >img{
        width: 112rem;
        height: 100%;
        object-fit: cover;
    }

    .content {
        width: 65%;
        height: 100%;

        h5 {
            font-size: 14rem;
            color: #000;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        p {
            margin-top: 5rem;
            font-size: 12rem;
            height: 40rem;
            line-height: 20rem;
            width: 100%;
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .icons {
            position: absolute;
            right: 15rem;
            bottom: 0;
            color: #999;

            img {
                width: 15rem;
                height: auto;
                margin: 0 5rem;
            }
        }
    }
}
</style>